(function(){
    'use strict';

    angular
    .module('appback')
    .controller('NovarumController', NovarumController)
 
    NovarumController.$inject = ["GenerallabService","NovarumService","$http","$timeout","$uibModal", "$log", "$document","$sce"];
              
    function NovarumController(GenerallabService,NovarumService,$http,$timeout,$uibModal, $log, $document,$sce)
    {                         
        var vm = this;
        vm.generalLab = GenerallabService;
        vm.novarum = {};
       	vm.cambiarInter = function(id){
       		console.log("chanbge",vm.novarum);
       		if(angular.isDefined(vm.novarum[id])){

       			NovarumService.guardarinterp(id,vm.novarum[id],function(data){
        			//location.reload();
        		});
        		
       			console.log("novarum",vm.novarum[id]);
       		}
       	}
    }
  
})();